import { Sequence } from '@forchange/storytime';

class SequenceQueue {
  private queue: Sequence[];
  portalId: string;
  constructor(portalId: string, queue?: []) {
    this.queue = [];
    this.portalId = portalId;
  }

  push(sequence: Sequence): boolean {
    this.queue.push(sequence);
    return true;
  }
  pop(): Sequence | undefined {
    return this.queue.shift();
  }
  getFront(): Sequence | undefined {
    return this.queue[0];
  }
  getRear(): Sequence | undefined {
    return this.queue[this.queue.length - 1];
  }
  clear(): void {
    this.queue = [];
  }
  get size(): number {
    return this.queue.length;
  }

  json() {
    return JSON.stringify({
      queue: JSON.stringify(this.queue),
      portalId: this.portalId
    });
  }

  static init(sq: string) {
    const content = JSON.parse(sq);
    return new SequenceQueue(content.portalId, JSON.parse(content.queue));
  }
}

export default SequenceQueue;
